<template>
  <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
    <div class="row mb-3 mt-3 align-items-center">
      <div class="col-md-5">
        <b-button-group class="flex-wrap">
          <b-button variant="outline-danger">
            <input
              type="checkbox"
              v-model="selectAll"
              @change="selectItemAll(selectAll)"
            />
          </b-button>
          <b-button
            variant="outline-danger"
            type="button"
            :disabled="recordIds.length == 0"
            @click="multiDelete"
            v-if="$role == 'super_admin'"
          >
            <i class="fa fa-trash"></i>
            {{ $t("site.bulk_delete") }}
          </b-button>
          <b-button variant="outline-warning">نسخ</b-button>
          <b-button variant="outline-warning">Excel</b-button>
          <b-button variant="outline-warning">CSV</b-button>
          <b-button variant="outline-warning">PDF</b-button>
          <b-button variant="outline-warning">طباعة</b-button>
        </b-button-group>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <input
            type="text"
            name="users"
            class="form-control"
            v-model="search"
            autocomplete="off"
            readonly
            onfocus="this.removeAttribute('readonly');"
            @input="(val) => searchChange(val)"
            :placeholder="$t(`site.search`)"
          />
        </div>
      </div>
      <div class="col-md-2">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown
            id="ddown2"
            right
            :text="`${perPage}`"
            variant="outline-warning"
            size="xs"
          >
            <b-dropdown-item
              v-for="(size, index) in [5, 10, 20, 50, 100]"
              :key="index"
              @click="changePageSize(size)"
              >{{ size }}</b-dropdown-item
            >
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table :stacked="($mobile==1)" 
          ref="table"
          class="vuetable"
          sort-by="id"
          sort-desc.sync="false"
          :current-page="currentPage"
          :fields="bootstrapTable.fields"
          :items="dataProvider"
        >
          <template #cell(checkbox)="data">
            <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
              <input
                type="checkbox"
                v-model="recordIds"
                :value="data.item.id"
                @change="selectItem(data)"
              />
              <span></span>
            </label>
          </template>
          <template #cell(teachers_count)="data">
            <b-button
              v-b-modal.modal-info
              variant="outline-info"
              @click="showUser(data.item, 'teacher', '')"
            >
              {{ data.item.master_teachers.length }}
            </b-button>
          </template>
          <template #cell(assign_teachers)="data">
            <b-button
              v-b-modal.modal-info
              variant="outline-info"
              @click="
                assignTeachers(
                  data.item,
                  'teacher',
                  $t('master.assign_teachers')
                )
              "
            >
              {{ $t("master.assign_teachers") }}
            </b-button>
          </template>
          <!-- <template #cell(edit)="data">
            <button
              class="btn btn-icon btn-warning btn-sm"
              @click="editItem(data)"
            >
              <i class="fa fa-edit"></i>
            </button>
            <button
              class="btn btn-icon btn-danger btn-sm"
              @click="deleteItem(data)"
              v-if="$role == 'super_admin'"
            >
              <i class="fa fa-trash"></i>
            </button>
          </template> -->
        </b-table>
        <hr />

        <b-pagination
          v-model="currentPage"
          align="right"
          class="dataTables_paginate paging_simple_numbers pagination-warning"
          :total-rows="totalRows"
          :per-page="perPage"
        >
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>
        <!-- end of table -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
    <b-modal
      id="modal-info"
      :ok-disabled="guideId===''||flag===false?true:false"
      ok-only
      ok-variant="info"
      modal-class="modal-info"
      centered
      @ok="hide"
      size="lg"
      :title="title"
    >
      <b-table :stacked="($mobile==1)"  :items="users" :fields="userfields">
        <template #cell(checkbox)="data">
          <b-form-checkbox v-model="usersSelelcted" :value="data.item.id" @change="handle($event,data.item.id)">
          </b-form-checkbox>
        </template>
        <template #cell(guide)="data">
                <b-form-checkbox
                      v-model="guideId"
                      class="custom-control-info"
                      name="check-button"
                      :value="guideId===data.item.id?guideId:1"
                      switch
                      @change="check($event,data.item.id)"
                /> 
        </template>
      </b-table>

      <!-- <b-spinner v-else type="grow" label="Loading..."  class="loading" /> -->
    </b-modal>
  </div>
</template>

<script>
import controller from "../../../../Controllers/UsersController";
import config from "../../../../config/config";
import Auth from "@/Apis/Auth";
import Swal from "sweetalert2";
import vSelect from "vue-select";
const appLoading = document.getElementById("loading-bg");

export default {
  name: "UsersDataTable",
  props: ["items", "editItem"],
    components: {
    vSelect,
  },
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          { key: "checkbox", label: "", sortable: false },
          {
            key: "code",
            label: this.$i18n.t("students.academic_number"),
            sortable: true,
          },
          {
            key: "first_name",
            label: this.$i18n.t("students.first_name"),
            sortable: true,
          },
          {
            key: "last_name",
            label: this.$i18n.t("students.last_name"),
            sortable: true,
          },

          {
            key: "email",
            label: this.$i18n.t("users.email"),
            sortable: true,
          },
          {
            key: "country.name",
            label: this.$i18n.t("countries.country"),
            sortable: false,
          },
        ],
      },
      data: {},
      selectAll: false,
      
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      user: {},
      eduPrograms: [],
      users: [],
      usersSelelcted: [],
      teachersSelelcted: [],
      studentSelelcted: {},
      title:'',
      types:["supervisor","guide"],
      guideId:'',
      flag:false,
      assign:false,
      userfields: [
        { key: "checkbox", label: "", sortable: false },
        {
          key: "code",
          label: this.$i18n.t("students.academic_number"),
          sortable: true,
          
        },
        {
          key: "first_name",
          label: this.$i18n.t("students.first_name"),
          sortable: true,
          
        },
        {
          key: "last_name",
          label: this.$i18n.t("students.last_name"),
          sortable: true,
          
        },

        {
          key: "email",
          label: this.$i18n.t("users.email"),
          sortable: true,
          
        },
                {
          key: "guide",
          label: this.$i18n.t("master.guide"),
          sortable: true,
          
        },
      ],
    };
  },
  created() {
      if(Auth.USER.account_type==='admin'){
        this.bootstrapTable.fields.splice(6,0, {
            key: "teachers_count",
            label: this.$i18n.t("master.teachers_count"),
            sortable: false,
          })
        this.bootstrapTable.fields.splice(7,0, {
            key: "assign_teachers",
            label: this.$i18n.t("master.assign_teachers"),
            sortable: false,
          })
      }
    // if (this.$route.name == "Teachers" || this.$route.name == "Students") {
    //   this.bootstrapTable.fields.splice(6, 0, {
    //     key: "rooms",
    //     label: this.$i18n.t("rooms.rooms"),
    //     sortable: false,
    //   });
    // }
    // if (this.$route.name == "Users") {
    //   this.type = "admin";
    // } else if (this.$route.name == "Teachers") {
    //   this.type = "teacher";
    // } else if (this.$route.name == "Students") {
    //   this.type = "student";
    // }
  },
  methods: {
    check(s,id){
      
      if(s!=false){
        if(this.usersSelelcted.includes(id)){
          this.flag=true;
            this.guideId=id;
        }else{
          this.usersSelelcted = this.studentSelelcted['master_teachers'].map((item) => item.id);
          if(this.assign===true){
            this.studentSelelcted['master_teachers'].map((item) => {
              if(item.pivot.type=='guide'){
                this.guideId=item.id;
              }
            });
            
          }else{
          this.guideId='';
          }

        }
      }else{
        this.usersSelelcted = this.studentSelelcted['master_teachers'].map((item) => item.id);
        this.flag=false;
        if(this.assign===true){
          this.studentSelelcted['master_teachers'].map((item) => {
            if(item.pivot.type=='guide'){
              this.guideId=item.id;
            }
          });
        }else{
          this.guideId='';          
        }

      }
    },
    handle(s,id){
      console.log("manaa",this.usersSelelcted);
      if(s.length===0){
          this.flag=false;
      }else if(this.arrayEquals(this.usersSelelcted,this.studentSelelcted['master_teachers'].map((item) => item.id))&&this.assign===true){
        console.log("maaa");
        this.flag=false;
      }else{
        this.flag=true;
      }
      if(!this.usersSelelcted.includes(this.guideId)){
        this.flag=false;
        this.guideId='';
      }
    },
    arrayEquals(a, b) {
    return Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val, index) => val === b[index]);
    },
    async assignTeachers(item, type, title) {
      this.assign=true;
      this.title = title;
      this.studentSelelcted = item;
      this.flag=false;
      this.usersSelelcted = item['master_teachers'].map((item) => item.id);
      item['master_teachers'].map((item) => {
        if(item.pivot.type=='guide'){
           this.guideId=item.id;
        }
      });
      let users = await new controller().getTeachers(
        {master_supervise:true}
      );
      this.users = users.filter((a) => {
        return !this.usersSelelcted.includes(a.id);
      });
    },
    showUser(item, type, title) {
      this.assign=false
      this.title = title;
      this.flag=true;
      this.studentSelelcted = item;
      this.usersSelelcted = item['master_teachers'].map((item) => item.id);
      item['master_teachers'].map((item) => {
        if(item.pivot.type=='guide'){
           this.guideId=item.id;
        }
      });
      console.log(this.guideId);
      this.users = item['master_teachers'];
    },

    async hide() {
      console.log(this.studentSelelcted);
      let data=[];
      data=this.usersSelelcted.map((e)=>{
        return{
          'student_id': this.studentSelelcted.id,
          'teacher_id':e,
          'type':e===this.guideId?'guide':'supervisor'
        }
      });
      console.log(data);
      await new controller().saveTeachers( {
        data: data,
        student_id: this.studentSelelcted.id,
      });
      this.usersSelelcted = [];
      this.guideId='';
      this.$refs.table.refresh();
    },

    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().GetAll(this.apiParamsConverter());
      console.log(data);
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }

      apiParams.with = ["country","master_teachers"];
      apiParams.type = 'student';
      apiParams.is_master=1;
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    // changeActive(data) {
    //   new controller().ToggleActivation(data.id);
    // },
    deleteItem(data) {
      new controller().Delete(data.item.id, [], this.$refs.table);
    },
    multiDelete() {
      new controller().Delete(0, this.recordIds, this.$refs.table);
    },
    // async impersonate(data) {
    //   const res = await Auth.impersonate(data.item);
    //   console.log(res);
    //   if (res) {
    //     Swal.fire({
    //       position: "top-end",
    //       icon: "success",
    //       title: this.$i18n.t("site.successfully"),
    //       showConfirmButton: false,
    //       timer: 1000,
    //     }).then(() => {
    //       window.location.href = "/dashboard";
    //     });
    //   } else {
    //     Swal.fire({
    //       position: "center",
    //       icon: "error",
    //       title: "Oops...",
    //       text: res.message,
    //       showConfirmButton: false,
    //       timer: 1000,
    //     });
    //   }
    // },
  },
  // watch: {
  //   $route(to, from) {
  //     if (this.$route.name == "Users") {
  //       this.type = "admin";
  //     } else if (this.$route.name == "Teachers") {
  //       this.type = "teacher";
  //     } else if (this.$route.name == "Students") {
  //       this.type = "student";
  //     }
  //     this.$refs.table.refresh();
  //   },
  // },
};
</script>

